let STORAGE_ENGINE = localStorage
export let storage = {
  setItem: (key, value) => STORAGE_ENGINE.setItem(key, value),
  getItem: key => STORAGE_ENGINE.getItem(key),
  removeItem: key => STORAGE_ENGINE.removeItem(key),
}
